import MilestonesAnalytics from './MilestonesAnalytics';

export default MilestonesAnalytics;
